export default __webpack_public_path__ + "static/media/icon-people.24aea9ab.svg";